/**
 * The HTML `download` attribute cannot force a download here — it is ignored cross-origin — so a
 * share link is rewritten to Drive's direct-download form instead. A non-Drive URL is returned
 * untouched, so an S3 link still works.
 *
 * Does not handle Drive's virus-scan interstitial, which it interposes on direct downloads above
 * roughly 100MB.
 *
 * Becomes a no-op once DEV-1422 moves these documents to S3; those objects will need
 * `Content-Disposition: attachment` set on the bucket, since no client-side rewrite can force a
 * download from an origin that serves the file inline.
 */
export const getGoogleDriveDownloadUrl = (url: string): string => {
  if (!url.includes("drive.google.com")) {
    return url;
  }

  const fileIdMatch = url.match(/\/d\/([a-zA-Z0-9-_]+)/);
  if (fileIdMatch && fileIdMatch[1]) {
    return `https://drive.google.com/uc?export=download&id=${fileIdMatch[1]}`;
  }

  return url;
};

export const openUrlWithGoogleDriveSupport = (url: string): void => {
  const finalUrl = getGoogleDriveDownloadUrl(url);
  window.open(finalUrl, "_blank", "noopener,noreferrer");
};
